import { ComponentPropsWithoutRef } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export type IconProps = ComponentPropsWithoutRef<'span'> &
  VariantProps<typeof iconVariant> & {
    name: string;
    size?: 10 | 12 | 14 | 16 | 18 | 20 | 24 | 30;
    fill?: boolean;
  };

function Icon({ name, size = 24, fill = true, className, ...props }: IconProps) {
  return (
    <span className={cn(iconVariant({ size, fill }), className)} {...props}>
      {name}
    </span>
  );
}

const iconVariant = cva(['material-symbols-rounded', 'block'], {
  variants: {
    size: {
      10: 'text-[10px]',
      12: 'text-[12px]',
      14: 'text-[14px]',
      16: 'text-[16px]',
      18: 'text-[18px]',
      20: 'text-[20px]',
      24: 'text-[24px]',
      30: 'text-[30px]',
    },
    fill: {
      true: 'material-symbols-fill',
    },
  },
});
export default Icon;
